import { render } from "./ContainmentSolutions.vue?vue&type=template&id=0486c05d&scoped=true"
import script from "./ContainmentSolutions.vue?vue&type=script&lang=js"
export * from "./ContainmentSolutions.vue?vue&type=script&lang=js"

import "./ContainmentSolutions.vue?vue&type=style&index=0&id=0486c05d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0486c05d"]])

export default __exports__